<template>
	<q-tabs color="secondary" v-model="report">
		<q-tab slot="title" name="general" :label="$t('general')" />
		<q-tab
			slot="title"
			v-if="client_selected.has_courses"
			name="courses"
			:label="$t('online')"
		/>
		<q-tab
			slot="title"
			v-if="client_selected.has_live_classes"
			name="live_classes"
			:label="$t('live_classes')"
		/>
		<q-tab
			slot="title"
			v-if="client_selected.has_presential"
			name="presential"
			:label="$t('presential')"
		/>
		<q-tab slot="title" v-if="client_selected.has_trails" name="trails" :label="$t('trail')" />
		<q-tab
			slot="title"
			v-if="client_selected.has_webcasts"
			name="webcast"
			:label="$t('webcast')"
		/>
		<q-tab
			slot="title"
			v-if="client_selected.has_podcasts"
			name="podcasts"
			:label="$t('podcasts')"
		/>
		<q-tab
			slot="title"
			v-if="client_selected.has_drills"
			name="drills"
			:label="$t('drills')"
		/>

		<q-tab-pane name="general">
			<div class="row">
				<div class="col-12">
					<general :show_report="show_report" />
				</div>
			</div>
		</q-tab-pane>

		<q-tab-pane name="courses">
			<div class="row">
				<div class="col-12">
					<q-tabs color="primary" v-model="type_courses">
						<q-tab slot="title" name="results" :label="$t('results')" />
						<q-tab slot="title" name="classes" :label="$t('classes')" />
						<q-tab slot="title" name="games" :label="$t('games')" />
						<q-tab slot="title" name="tests" :label="$t('tests')" />
						<q-tab
							slot="title"
							v-if="client_selected.use_training_subscription"
							name="registrations"
							:label="$t('registrations')"
						/>
						<q-tab slot="title" name="available" :label="$t('availables')" />
						<q-tab
							slot="title"
							name="certificates"
							:label="$t('expired_certificates')"
							v-if="client_selected.use_group_trainings_certificate_expiration"
						/>

						<q-tab-pane name="results">
							<courses-results />
						</q-tab-pane>
						<q-tab-pane name="classes">
							<courses-classes />
						</q-tab-pane>
						<q-tab-pane name="games">
							<courses-games />
						</q-tab-pane>
						<q-tab-pane name="tests">
							<courses-tests />
						</q-tab-pane>
						<q-tab-pane name="registrations">
							<courses-registrations />
						</q-tab-pane>
						<q-tab-pane name="available">
							<courses-available v-if="client_selected.use_training_subscription" />
							<courses-available-false v-else />
						</q-tab-pane>
						<q-tab-pane name="certificates" v-if="client_selected.use_group_trainings_certificate_expiration">
							<courses-certificate />
						</q-tab-pane>
					</q-tabs>
				</div>
			</div>
		</q-tab-pane>

		<q-tab-pane name="live_classes">
			<div class="row">
				<div class="col-12">
					<q-tabs color="primary" v-model="type_live">
						<q-tab slot="title" name="results" :label="$t('results')" />
						<q-tab slot="title" name="participations" :label="$t('participations')" />
						<q-tab slot="title" name="tests" :label="$t('tests')" />
						<q-tab slot="title" name="registrations" :label="$t('registrations')" />
						<q-tab slot="title" name="available" :label="$t('availables')" />

						<q-tab-pane name="results">
							<live-classes-results />
						</q-tab-pane>
						<q-tab-pane name="participations">
							<live-classes-participations />
						</q-tab-pane>
						<q-tab-pane name="tests">
							<live-classes-tests />
						</q-tab-pane>
						<q-tab-pane name="registrations">
							<live-classes-registrations />
						</q-tab-pane>
						<q-tab-pane name="available">
							<live-classes-available />
						</q-tab-pane>
					</q-tabs>
				</div>
			</div>
		</q-tab-pane>

		<q-tab-pane name="presential">
			<div class="row">
				<div class="col-12">
					<q-tabs color="primary" v-model="type_presential">
						<q-tab slot="title" name="results" :label="$t('results')" />
						<q-tab slot="title" name="events" :label="$t('events')" />
						<q-tab slot="title" name="tests" :label="$t('tests')" />
						<q-tab slot="title" name="scheduled" :label="$t('pending_plural')" />
						<q-tab slot="title" name="registrations" :label="$t('registrations')" />
						<q-tab slot="title" name="available" :label="$t('availables')" />
						<q-tab
							slot="title"
							name="certificates"
							:label="$t('expired_certificates')"
							v-if="client_selected.use_presential_events_certificate_expiration"
						/>

						<q-tab-pane name="results">
							<presential-results />
						</q-tab-pane>
						<q-tab-pane name="events">
							<presential-events />
						</q-tab-pane>
						<q-tab-pane name="tests">
							<presential-tests />
						</q-tab-pane>
						<q-tab-pane name="scheduled">
							<presential-scheduled />
						</q-tab-pane>
						<q-tab-pane name="registrations">
							<presential-registrations />
						</q-tab-pane>
						<q-tab-pane name="available">
							<presential-available />
						</q-tab-pane>
						<q-tab-pane name="certificates" v-if="client_selected.use_presential_events_certificate_expiration">
							<presential-certificate />
						</q-tab-pane>
					</q-tabs>
				</div>
			</div>
		</q-tab-pane>

		<q-tab-pane name="trails">
			<div class="row">
				<div class="col-12">
					<q-tabs color="primary" v-model="type_trails">
						<q-tab slot="title" name="results" :label="$t('results')" />
						<q-tab
							slot="title"
							v-if="client_selected.use_trail_subscription"
							name="registrations"
							:label="$t('registrations')"
						/>
						<q-tab slot="title" name="available" :label="$t('availables')" />

						<q-tab-pane name="results">
							<trails-results />
						</q-tab-pane>
						<q-tab-pane name="registrations">
							<trails-registrations />
						</q-tab-pane>
						<q-tab-pane name="available">
							<trails-available v-if="client_selected.use_trail_subscription" />
							<trails-available-false v-else />
						</q-tab-pane>
					</q-tabs>
				</div>
			</div>
		</q-tab-pane>

		<q-tab-pane name="webcast">
			<div class="row">
				<div class="col-12">
					<q-tabs color="primary" v-model="type_webcast">
						<q-tab slot="title" name="results" :label="$t('results')" />
						<q-tab slot="title" name="participations" :label="$t('participations')" />
						<q-tab slot="title" name="tests" :label="$t('tests')" />
						<q-tab slot="title" name="registrations" :label="$t('registrations')" />
						<q-tab slot="title" name="available" :label="$t('availables')" />

						<q-tab-pane name="results">
							<webcast-results />
						</q-tab-pane>
						<q-tab-pane name="participations">
							<webcast-participations />
						</q-tab-pane>
						<q-tab-pane name="tests">
							<webcast-tests />
						</q-tab-pane>
						<q-tab-pane name="registrations">
							<webcast-registrations />
						</q-tab-pane>
						<q-tab-pane name="available">
							<webcast-available />
						</q-tab-pane>
					</q-tabs>
				</div>
			</div>
		</q-tab-pane>

		<q-tab-pane name="podcasts">
			<div class="row">
				<div class="col-12">
					<q-tabs color="primary" v-model="type_podcast">
						<q-tab slot="title" name="results" :label="$t('results')" />
						<q-tab slot="title" name="favorites" :label="$t('favorites')" />
						<q-tab slot="title" name="available" :label="$t('availables')" />

						<q-tab-pane name="results">
							<podcasts-results />
						</q-tab-pane>
						<q-tab-pane name="favorites">
							<podcasts-favorites />
						</q-tab-pane>
						<q-tab-pane name="available">
							<podcasts-available />
						</q-tab-pane>
					</q-tabs>
				</div>
			</div>
		</q-tab-pane>

		<q-tab-pane name="drills">
			<div class="row">
				<div class="col-12">
					<q-tabs color="primary" v-model="type_courses">
						<q-tab slot="title" name="results" :label="$t('results')" />
						<q-tab slot="title" name="available" :label="$t('availables')" />

						<q-tab-pane name="results">
							<drills-results />
						</q-tab-pane>
						<q-tab-pane name="available">
							<drills-available />
						</q-tab-pane>
					</q-tabs>
				</div>
			</div>
		</q-tab-pane>
	</q-tabs>
</template>

<script>
import General from 'components/admin/users/General'

import CoursesResults from 'components/admin/users/courses/Results'
import CoursesClasses from 'components/admin/users/courses/Classes'
import CoursesGames from 'components/admin/users/courses/Games'
import CoursesTests from 'components/admin/users/courses/Tests'
import CoursesRegistrations from 'components/admin/users/courses/Registrations'
import CoursesPending from 'components/admin/users/courses/Pending'
import CoursesAvailable from 'components/admin/users/courses/Available'
import CoursesAvailableFalse from 'components/admin/users/courses/AvailableFalse'
import CoursesCertificate from 'components/admin/users/courses/Certificate'

import LiveClassesResults from 'components/admin/users/live_classes/Results'
import LiveClassesParticipations from 'components/admin/users/live_classes/Participations'
import LiveClassesTests from 'components/admin/users/live_classes/Tests'
import LiveClassesRegistrations from 'components/admin/users/live_classes/Registrations'
import LiveClassesAvailable from 'components/admin/users/live_classes/Available'

import PresentialResults from 'components/admin/users/presential/Results'
import PresentialEvents from 'components/admin/users/presential/Events'
import PresentialTests from 'components/admin/users/presential/Tests'
import PresentialScheduled from 'components/admin/users/presential/Scheduled'
import PresentialAvailable from 'components/admin/users/presential/Available'
import PresentiaCertificate from 'components/admin/users/presential/Certificate'
import PresentialRegistrations from 'components/admin/users/presential/Registrations'

import TrailsResults from 'components/admin/users/trails/Results/Results'
import TrailsRegistrations from 'components/admin/users/trails/Registrations'
import TrailsAvailable from 'components/admin/users/trails/Available'
import TrailsAvailableFalse from 'components/admin/users/trails/AvailableFalse'

import WebinarsResults from 'components/admin/users/webinars/Results'
import WebinarsParticipations from 'components/admin/users/webinars/Participations'
import WebinarsTests from 'components/admin/users/webinars/Tests'
import WebinarsRegistrations from 'components/admin/users/webinars/Registrations'
import WebinarsAvailable from 'components/admin/users/webinars/Available'

import PodcastsResults from 'components/admin/users/podcasts/Results'
import PodcastsAvailable from 'components/admin/users/podcasts/Available'
import PodcastsFavorites from 'components/admin/users/podcasts/Favorites'

import DrillsResults from 'components/admin/users/drills/Results'
import DrillsAvailable from 'components/admin/users/drills/Available'

import { mapGetters } from 'vuex'

export default {
	i18nOptions: {
		namespaces: [
			'custom',
			'common',
			'users',
			'feed',
			'webcast',
			'courses',
			'games',
			'training',
			'trails',
			'presential',
			'admin',
			'podcasts',
			'courses',
		],
	},

	props: ['clear_data', 'show_report'],

	data() {
		return {
			report: 'general',
			type_courses: 'results',
			type_live: 'results',
			type_presential: 'results',
			type_trails: 'results',
			type_webcast: 'results',
			type_podcast: 'results',
		}
	},

	components: {
		general: General,

		'courses-results': CoursesResults,
		'courses-classes': CoursesClasses,
		'courses-games': CoursesGames,
		'courses-tests': CoursesTests,
		'courses-pending': CoursesPending,
		'courses-available': CoursesAvailable,
		'courses-available-false': CoursesAvailableFalse,
		'courses-registrations': CoursesRegistrations,
		'courses-certificate': CoursesCertificate,

		'live-classes-results': LiveClassesResults,
		'live-classes-participations': LiveClassesParticipations,
		'live-classes-tests': LiveClassesTests,
		'live-classes-registrations': LiveClassesRegistrations,
		'live-classes-available': LiveClassesAvailable,

		'presential-results': PresentialResults,
		'presential-events': PresentialEvents,
		'presential-tests': PresentialTests,
		'presential-scheduled': PresentialScheduled,
		'presential-available': PresentialAvailable,
		'presential-certificate': PresentiaCertificate,
		'presential-registrations': PresentialRegistrations,

		'trails-results': TrailsResults,
		'trails-registrations': TrailsRegistrations,
		'trails-available': TrailsAvailable,
		'trails-available-false': TrailsAvailableFalse,

		'webcast-results': WebinarsResults,
		'webcast-participations': WebinarsParticipations,
		'webcast-tests': WebinarsTests,
		'webcast-registrations': WebinarsRegistrations,
		'webcast-available': WebinarsAvailable,

		'podcasts-results': PodcastsResults,
		'podcasts-available': PodcastsAvailable,
		'podcasts-favorites': PodcastsFavorites,

		'drills-results': DrillsResults,
		'drills-available': DrillsAvailable,
	},

	computed: {
		...mapGetters({
			clients: 'params/clients',
			params_loaded: 'params/params_loaded',
			id_user_client_selected: 'common/id_user_client_selected',
		}),

		client_selected() {
			let obj = this.clients.find((obj) => obj.id == this.id_user_client_selected)

			if (obj) return obj
			else {
				return {
					has_courses: false,
					has_live_classes: false,
					has_presential: false,
					has_trails: false,
					has_webcasts: false,
					has_podcasts: false,
					has_drills: false,
					use_trail_subscription: false,
					use_training_subscription: false,
				}
			}
		},
	},
	watch: {
		clear_data: function() {
			this.report = 'general'
			this.type_courses = 'results'
			this.type_live = 'results'
			this.type_trails = 'results'
			this.type_webinars = 'results'
			this.type_podcasts = 'results'
		},
	},
}
</script>

<style></style>
